import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0728fe7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "message" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "需要回访", -1))
const _hoisted_4 = {
  key: 0,
  class: "table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "序号"),
  /*#__PURE__*/_createElementVNode("td", null, "姓名"),
  /*#__PURE__*/_createElementVNode("td", null, "操作")
], -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("前往")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "上课异常", -1))
const _hoisted_9 = {
  key: 2,
  class: "table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "序号"),
  /*#__PURE__*/_createElementVNode("td", null, "姓名"),
  /*#__PURE__*/_createElementVNode("td", null, "操作")
], -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("前往")
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "其他预警", -1))
const _hoisted_14 = {
  key: 4,
  class: "table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "姓名"),
  /*#__PURE__*/_createElementVNode("td", null, "身份"),
  /*#__PURE__*/_createElementVNode("td", null, "预警原因")
], -1))
const _hoisted_16 = { key: 5 }

import { ElMessage } from "element-plus";
import { onMounted, ref, Ref } from "vue";
import { useRouter } from "vue-router";
import { getInfoByClass } from "../../config/interface";
type Record = {
  date: string;
  record: string;
  nextVisit: string;
};
// 定义状态

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter(); // 创建路由
// const dialogVisible = ref<Boolean>(false); // 控制对话框显示状态
const dialogVisible: Ref<Boolean> = ref(false);
let back = "<";
// 接口返回数据
const returnInfo = ref({
  visitErrors: [],
  classErrors: [],
  otherErrors: [],
});
// 临时存放回访信息
const visitInfo = ref<Record>({
  date: "",
  record: "",
  nextVisit: "",
});

// 定义方法
const goOrder = (id: number) => {
  router.push({
    name: "Order",
    params: { id },
  });
};
const handleBack = () => {
  router.back();
};

// 使用钩子
onMounted(() => {
  getInfoByClass({}).then((res) => {
    console.log(res);
    if (res.data && res.data.success) {
      returnInfo.value = res.data.data;
      console.log(returnInfo.value);
    } else {
      ElMessage.error(res.data.msg);
    }
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back",
        onClick: handleBack
      }, _toDisplayString(_unref(back)) + " 返回", 1)
    ]),
    _hoisted_3,
    (returnInfo.value.visitErrors.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnInfo.value.visitErrors, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: ($event: any) => (goOrder(item.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!returnInfo.value.visitErrors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无需要处理的内容"))
      : _createCommentVNode("", true),
    _hoisted_8,
    (returnInfo.value.classErrors.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnInfo.value.classErrors, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: ($event: any) => (goOrder(item.id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!returnInfo.value.classErrors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, "暂无需要处理的内容"))
      : _createCommentVNode("", true),
    _hoisted_13,
    (returnInfo.value.otherErrors.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
          _hoisted_15,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnInfo.value.otherErrors, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, _toDisplayString(item.identity), 1),
              _createElementVNode("td", null, _toDisplayString(item.content), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!returnInfo.value.otherErrors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, "暂无需要处理的内容"))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: "回访记录",
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: visitInfo.value,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "回访日期",
              prop: "date",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: visitInfo.value.date,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visitInfo.value.date) = $event)),
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "回访记录",
              prop: "record",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: visitInfo.value.record,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visitInfo.value.record) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "下次回访时间",
              prop: "nextVisit",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: visitInfo.value.nextVisit,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visitInfo.value.nextVisit) = $event)),
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})